
import { Zap, Twitter, Linkedin, Instagram, Facebook, ArrowUpRight, Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-background/90 backdrop-blur-sm border-t border-white/5">
      <div className="max-w-7xl mx-auto py-16 px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="space-y-6">
            <a href="#" className="flex items-center space-x-2">
              <Zap className="h-8 w-8 text-secondary" />
              <span className="text-2xl font-display font-bold tech-gradient-text">
                BakerTech
              </span>
            </a>
            <p className="text-foreground/70">
              Empowering startups and small businesses with cutting-edge technology solutions for growth and innovation.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="p-2 bg-white/5 rounded-full hover:bg-white/10 transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="p-2 bg-white/5 rounded-full hover:bg-white/10 transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="p-2 bg-white/5 rounded-full hover:bg-white/10 transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="p-2 bg-white/5 rounded-full hover:bg-white/10 transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Our Services</h3>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-foreground/70 hover:text-foreground transition-colors">Web Design</a>
              </li>
              <li>
                <a href="#services" className="text-foreground/70 hover:text-foreground transition-colors">SEO Optimization</a>
              </li>
              <li>
                <a href="#services" className="text-foreground/70 hover:text-foreground transition-colors">Graphic Design</a>
              </li>
              <li>
                <a href="#services" className="text-foreground/70 hover:text-foreground transition-colors">Software Creation</a>
              </li>
              <li>
                <a href="#services" className="text-foreground/70 hover:text-foreground transition-colors">Server Maintenance</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-foreground/70 hover:text-foreground transition-colors">Home</a>
              </li>
              <li>
                <a href="#about" className="text-foreground/70 hover:text-foreground transition-colors">About Us</a>
              </li>
              <li>
                <a href="#services" className="text-foreground/70 hover:text-foreground transition-colors">Services</a>
              </li>
              <li>
                <a href="#contact" className="text-foreground/70 hover:text-foreground transition-colors">Contact</a>
              </li>
              <li>
                <a href="#" className="text-foreground/70 hover:text-foreground transition-colors">Privacy Policy</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-secondary mt-0.5" />
                <a href="mailto:22jlbaker@gmail.com" className="text-foreground/70 hover:text-foreground transition-colors">22jlbaker@gmail.com</a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-primary mt-0.5" />
                <a href="tel:6365777481" className="text-foreground/70 hover:text-foreground transition-colors">(636) 577-7481</a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-accent mt-0.5" />
                <span className="text-foreground/70">Mizzou, Columbia, MO</span>
              </li>
            </ul>
            
            <form className="mt-6">
              <label className="block text-sm font-medium text-foreground/70 mb-2">Subscribe to our newsletter</label>
              <div className="flex">
                <input 
                  type="email" 
                  placeholder="Your email" 
                  className="px-4 py-2 bg-white/5 text-foreground rounded-l-md w-full focus:outline-none focus:bg-white/10"
                />
                <button 
                  type="submit"
                  className="bg-primary hover:bg-primary/90 px-3 rounded-r-md flex items-center justify-center transition-colors"
                >
                  <ArrowUpRight className="h-5 w-5" />
                </button>
              </div>
            </form>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center">
          <p className="text-foreground/50 text-center md:text-left mb-4 md:mb-0">
            &copy; {currentYear} BakerTech. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-foreground/50 hover:text-foreground transition-colors">Terms</a>
            <a href="#" className="text-foreground/50 hover:text-foreground transition-colors">Privacy</a>
            <a href="#" className="text-foreground/50 hover:text-foreground transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
